/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import audience from "../../../../assets/AttributeCategory/audience.svg";
import content from "../../../../assets/AttributeCategory/content.svg";
import tag from "../../../../assets/AttributeCategory/tag.svg";
import theme from "../../../../assets/AttributeCategory/theme.svg";
import xAttr from "../../../../assets/xAttr.svg";
import engagement from "../../../../assets/AttributeCategory/engagement.svg";
import Reuser from "../../../../assets/AttributeCategory/Reuser.svg";
import CustomAttribute from "../../../../assets/AttributeCategory/Custom_Attribute-blue.svg";
import AI from "../../../../assets/AttributeCategory/AI.svg";
import ticket_icon from "../../../../assets/AttributeCategory/ticket_icon.svg";

import noSearchResult from "../../../../assets/No_Result_Found.svg";

import StackGrid from "react-stack-grid";
import beta from "../../../../assets/beta.svg";
import betaActive from "../../../../assets/betaActive.svg";
import betaHover from "../../../../assets/betaHover.svg";

const image = {
  //logo images
  1: theme,
  2: audience,
  3: content,
  4: content,
  5: engagement,
  6: tag,
  7: Reuser,
  8: AI,
  9: CustomAttribute,
};

const PrimeAttrSelect = (props) => {
  const { onChange, value, isActive, setisActive, title } = props;
  //redux states
  const authParams = useSelector((state) => state.Authentication.authParams);
  const config = useSelector((state) => state.apiCall.config); // get_config data
  const allAttributes = useSelector(
    (state) => state?.attributes?.allAttributes
  ); //all attributes title and backend name
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions?.[`exclude-x-y-attrs`]
  );
  const [categorySearch, setcategorySearch] = useState(
    allAttributes && allAttributes[value]
  ); //search data stored in this state
  const [filterData, setFilterData] = useState([]); //data gets filtered according to search values
  const [dimensions] = useState({ width: 0, height: 0 });
  const graphLoader = useSelector((state) => state.apiCall.loader); //display chart loader
  const node = useRef();

  let data =
    config?.status === "successful" && config?.result?.schema && typeof config.result.schema === 'object' && config.result.schema !== null
      ? Object.entries(config?.result?.schema)
      : null; //schema data
  useEffect(() => {
    //default value is title name i.e first attribute name
    title && setcategorySearch(title);
  }, [title]);

  // responsible for filtering configuration data and returning an object with valid categories and in
  // configuration schema
  function createFilterData(searchString) {
    let dummyFilterData;
    if (searchString === "" || searchString === "None") {
      // create a deep copy of configuration data

      dummyFilterData = [];
      data.map((element) => {
        // create a deep copy of category data
        element = JSON.parse(JSON.stringify(element));
        let searchMembers = {};

        if (element[1]?.members) {
          Object.entries(element[1]?.members).map((member) => {
            // check if title contains alphabets from search string

            if (member[1].primary) {
              searchMembers[member[0]] = member[1];
            }
            return null;
          });
          // if category with attributes is found the add it to dummy object
          if (Object.keys(searchMembers).length !== 0) {
            let new_element = element;
            new_element[1].members = searchMembers;
            dummyFilterData.push(new_element);
          }
        }
        return null;
      });
    } else {
      dummyFilterData = [];
      data.map((element) => {
        // create a deep copy of category data
        element = JSON.parse(JSON.stringify(element));
        let searchMembers = {};

        if (element[1]?.members) {
          Object.entries(element[1]?.members).map((member) => {
            // check if title contains alphabets from search string

            if (
              member[1].title
                ?.toLowerCase()
                .includes(searchString?.toLowerCase()) &&
              member[1].primary
            ) {
              searchMembers[member[0]] = member[1];
            }
            return null;
          });
          // if category with attributes is found the add it to dummy object
          if (Object.keys(searchMembers).length !== 0) {
            let new_element = element;
            new_element[1].members = searchMembers;
            dummyFilterData.push(new_element);
          }
        }
        return null;
      });
    }
    return dummyFilterData;
  }

  const onSearch = (event) => {
    setisActive(true);
    setcategorySearch(event.target.value); //set state
    setFilterData(createFilterData(event.target.value)); //call function and set filterData state
  };

  const megaMenu = (e) => {
    if (node?.current?.contains(e?.target)) {
      return;
    }
    setisActive(false);
  };

  const handleChange = (selectedValue) => {
    //onclick function
    if (allAttributes[value] === categorySearch) {
      setFilterData(createFilterData("")); //to show all the data in dropdown after an option is selected
    } else {
      setFilterData(createFilterData(categorySearch)); //if no option is selected search text is filtered
    }

    setisActive(!isActive);
  };

  const onBlurr = () => {
    //when clicked outside input box it will reset the unwanted text
    Object.entries(allAttributes).map((a, i) => {
      if (!a[1].includes(categorySearch)) {
        setcategorySearch(allAttributes[value]);
      }
      return null;
    });
    if (value !== null && categorySearch === "") {
      setcategorySearch(allAttributes[value]);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", megaMenu);
    return () => {
      document.removeEventListener("mousedown", megaMenu);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      ref={node}
      className={`hs-menu-initialized ${
        isActive ? "hs-mega-menu-opened" : ""
      } ${graphLoader ? "disable" : ""}`}
    >
      <div
        className="floating-label-group input-duration"
        style={{ height: "4rem" }}
      >
        <img
          src={xAttr}
          className="position-absolute"
          alt="X axis Attribute"
          style={{
            zIndex: "1",
            top: "1.2rem",
            left: "0.8rem",
            maxWidth: "1.5rem",
          }}
        />
        <input
          type="text"
          data-toggle="dropdown"
          className="portlet-input scroll__input"
          value={categorySearch}
          onChange={(e) => onSearch(e)}
          onKeyUp={(e) => onSearch(e)}
          onClick={(e) => handleChange(e)}
          onBlur={onBlurr}
          required
          style={{ paddingLeft: "2.8rem" }}
        />
        <span
          className="position-absolute"
          style={{
            zIndex: "1",
            top: "1rem",
            right: "1.2rem",
            maxWidth: "1.5rem",
          }}
          onClick={(e) => handleChange(e)}
        >
          <i
            style={{
              color: authParams?.theme_type === "1" ? "#fff" : "#2D3E5C",
            }}
            class="fas fa-regular fa-angle-down"
          ></i>
        </span>
        <label
          className="portlet-label floating-label"
          style={{ marginLeft: "2rem" }}
        >
          X axis Attribute
        </label>
      </div>

      {isActive && (
        <div
          className={`hs-mega-menu u-header__sub-menu u-header__mega-menu-position-right-fix--md animated hs-position-right ${
            isActive ? "slideInUp" : "fadeOut"
          }`}
          style={{ display: isActive ? "block" : "none" }}
        >
          <div className="u-header__mega-menu-wrapper pt-15 pb-15 custom_scroll">
            {config && filterData?.length > 0 ? (
              <StackGrid columnWidth={205} className="Menu_grid">
                {config &&
                  filterData?.map((e, i) => {
                    if (e[1].is_group === true)
                      return (
                        <div
                          className="grid_items"
                          style={{
                            left: dimensions.width,
                            top: dimensions.height,
                          }}
                        >
                          <span className="u-header__sub-menu-title d-flex align-items-center">
                            <img
                              src={
                                image[e[1]?.id] ? image[e[1]?.id] : ticket_icon
                              }
                              alt={e[0]}
                              style={{ marginRight: "0.5rem" }}
                            />
                            {e[0]}
                          </span>
                          <ul className="u-header__sub-menu-nav-group">
                            {Object.entries(e[1]?.members)?.map((el, j) => {
                              return graphConditionConfig?.map((g) => {
                                if (el[0] !== g) {
                                  return (
                                    el[1]?.plottable && (
                                      <li
                                        className={`nav-link u-header__sub-menu-nav-link text-left ${
                                          allAttributes[value] === el[1]?.title
                                            ? "active"
                                            : ""
                                        }`}
                                        onClick={() => onChange(el[0])}
                                      >
                                        {el[1]?.title}
                                        {el[1]?.is_beta && (
                                          <>
                                            <img
                                              src={
                                                allAttributes[value] ===
                                                el[1]?.title
                                                  ? betaActive
                                                  : beta
                                              }
                                              className="ml-1 defalt-img"
                                            />
                                            <img
                                              src={betaHover}
                                              className="ml-1 hover-img"
                                            />
                                          </>
                                        )}
                                      </li>
                                    )
                                  );
                                }
                              });
                            })}
                          </ul>
                        </div>
                      );
                    return null;
                  })}
              </StackGrid>
            ) : (
              <div className="w-100 text-center">
                <div className="Nodata_img mb-15">
                  <img
                    src={noSearchResult}
                    alt="no data"
                    style={{ maxWidth: "8rem" }}
                  />
                </div>
                <div className="text_regular-gray">No search results found</div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PrimeAttrSelect;
